/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from "@cian/http-api/shared/model";

export type TApplyForPublicationModel = IModel<
  IApplyForPublicationRequest,
  TApplyForPublicationResponse
>;

export interface IApplyForPublicationRequest {
  /** Название компании **/
  companyName: string;
  /** Вид деятельности **/
  companyType: ECompanyType;
  /** E-mail **/
  email: string;
  /** Телефон **/
  phone: string;
}

export type TApplyForPublicationResponse =
  | IApplyForPublicationResponse200
  | IApplyForPublicationResponse400;

export interface IApplyForPublicationResponse200
  extends IModelResponse<IApplyForPublicationResponse> {
  statusCode: 200;
}

export interface IApplyForPublicationResponse400
  extends IModelResponse<IApplyForPublicationResponseError> {
  statusCode: 400;
}

export interface IApplyForPublicationResponse {
  /** Запрос успешно создан **/
  status: string;
}

export interface IApplyForPublicationResponseError {
  errors: any[];
  message: string;
}

export type TResponses =
  | IApplyForPublicationResponse
  | IApplyForPublicationResponseError;

export enum ECompanyType {
  /** Брокер **/
  Broker = "broker",
  /** Собственник бизнес-центра **/
  BusinessCenterOwner = "businessCenterOwner",
  /** Управляющая компания **/
  ManagementCompany = "managementCompany",
  /** Оператор коворкинга **/
  Operator = "operator"
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IApplyForPublicationResponse): TResponse200;
  400(response: IApplyForPublicationResponseError): TResponse400;
}
